import type { SignDocument } from "../Models/Domain";
import type { InputData } from "@/Components/Extend/HTMLEditor/interfaces";

import useSignDocuments from "../Store";

import { updateResponses } from "@/Services/TherapyApi/SignDocuments";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import SignDocumentTransformer from "@/Modules/Transformers/SignDocument";

import { hasValue } from "@/Utils/Objects";

async function UpdateResponsesActionHandler(
  uuid: string,
  responses: InputData[]
): Promise<SignDocument | undefined> {
  const signDocumentsStore = useSignDocuments();

  signDocumentsStore.isLoading = true;

  const resp = await updateResponses(uuid, responses).catch(() => undefined);

  if (isApiError(resp) || !hasValue(resp)) {
    return undefined;
  }

  return SignDocumentTransformer.toDomain(resp);
}

export default UpdateResponsesActionHandler;
